exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-container[data-v-be6b7bae]{white-space:nowrap;position:relative;overflow:hidden;width:100%}.scroll-container .deep .el-scrollbar__bar[data-v-be6b7bae]{bottom:0px}.scroll-container .deep .el-scrollbar__wrap[data-v-be6b7bae]{height:49px}", ""]);

// exports
